const getCardResponse = (rawData: any) => {
  const result = rawData?.data

  return {
    data: result.data,
    info: result.meta?.info,
  }
}

const contributionsLocationFormattedResponse = {
  getCardResponse,
}

export default contributionsLocationFormattedResponse
